import React, { useState } from 'react';
import { Theme, Typography } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import UserIcon from '@mui/icons-material/Person';
import Popper from '@mui/material/Popper';
import Grid from '@mui/material/Grid';
import Badge from '@mui/material/Badge';
import { Shopper } from 'common/types';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	shoppers: Shopper[];
	activeShopperIndex: number;
	activeShopperId: string;
	changeActiveShopperId: (activeShopperId: string) => void;
	addNewShopper?: () => void;
}

type Props = OwnProps & WithStyles<typeof styles>;

export const UserMenu = (props: Props) => {
	const {
		classes,
		shoppers,
		activeShopperIndex,
		addNewShopper,
		activeShopperId,
		changeActiveShopperId,
	} = props;
	const { t } = useTranslation();
	const [userMenuAnchor, setUserMenuAnchor] = useState<null | HTMLElement>(null);

	const handleUserMenuClose = (event: any) => {
		if (userMenuAnchor && userMenuAnchor.contains(event.target)) {
			return;
		}
		setUserMenuAnchor(null);
	};

	return (
		<React.Fragment>
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				className={classes.iconWrapper}
				onClick={(event: React.MouseEvent<HTMLElement>) =>
					setUserMenuAnchor(userMenuAnchor ? null : event.currentTarget)
				}
			>
				<Badge
					className={classes.leftIcon}
					badgeContent={
						shoppers.length === 1 ? shoppers.length : activeShopperIndex + 1 + '/' + shoppers.length
					}
					color="primary"
				>
					<UserIcon color="inherit" />
				</Badge>
			</Grid>
			<Popper
				open={Boolean(userMenuAnchor)}
				anchorEl={userMenuAnchor}
				transition
				disablePortal
				placement="top"
			>
				{({ TransitionProps }) => (
					<Grow {...TransitionProps}>
						<Paper>
							<ClickAwayListener onClickAway={handleUserMenuClose}>
								<MenuList onClick={handleUserMenuClose}>
									{addNewShopper ? (
										<MenuItem onClick={addNewShopper}>
											<Typography variant="body2">
												+ {t('common:actions.addPerson', 'Add person')}
											</Typography>
										</MenuItem>
									) : null}
									{props.shoppers.map((shopper, index) => (
										<MenuItem
											key={shopper.id + index}
											selected={shopper.id === activeShopperId}
											onClick={() => changeActiveShopperId(shopper.id)}
										>
											<Typography variant="body2">
												{' '}
												{t('common:person.person')} {index + 1}
											</Typography>
										</MenuItem>
									))}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</React.Fragment>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		iconWrapper: {
			display: 'flex',
			alignItems: 'center',
			height: '100%',
			cursor: 'pointer',
			flex: '1',
		},
		leftIcon: {
			marginRight: 12,
		},
	});

export default withStyles(styles)(UserMenu);
